const AciAirApiUrls = {
  GET: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/get`,
  POST: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/create`,
  PUT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/update`,
  DELETE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/delete`,
  DELETE_ALL: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/deleteAll`,
  EXPORT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/download`,
  CLONE: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/clone`,
  SUBMIT: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/submit`,
  SUBMIT_ALL: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/submitAll`,
  SEARCH: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/aci-air-search/get`,
  UPLOAD: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/csv/upload`,
  UPLOAD_CHECK: `${process.env.REACT_APP_USER_ACI_AIR_URL}/aci-air/acr/csv/check`,
};

export default AciAirApiUrls
